import BaseModel from "../base/baseModel";

export default class RecompensaModel extends BaseModel {
    id?: number = null;
    produtoId: number = null;
    produtoDescricao = "";
    pontosNecessarios = 0;
    ativo = true;
}
